import { useState } from 'react';
import { db } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { uploadImage } from '../utils';
import { BUSINESS_CATEGORIES } from '../constants';
import DateWheelPicker from './DateWheelPicker';

function LocationSection({ canPickLocation, pickedLocation, onPickLocation }) {
  const [showUpgradeMsg, setShowUpgradeMsg] = useState(false);

  const handleClick = () => {
    if (!canPickLocation) {
      setShowUpgradeMsg(true);
      return;
    }
    onPickLocation();
  };

  return (
    <div>
      <p style={{ margin: '0 0 6px', fontSize: 13, fontWeight: 500 }}>위치</p>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <span style={{ fontSize: 13, color: '#555', flex: 1 }}>
          {pickedLocation
            ? `📍 선택한 위치 (${pickedLocation[0].toFixed(4)}, ${pickedLocation[1].toFixed(4)})`
            : '📍 현재 위치 사용 중'}
        </span>
        <button
          type="button"
          onClick={handleClick}
          style={{
            padding: '6px 14px', borderRadius: 8, border: '1px solid #ddd',
            background: 'white', fontSize: 12, cursor: 'pointer', whiteSpace: 'nowrap',
          }}
        >
          위치 변경
        </button>
      </div>
      {showUpgradeMsg && (
        <div style={{
          marginTop: 8, padding: '10px 14px', borderRadius: 8,
          background: '#FFF3E0', border: '1px solid #FFB74D',
          fontSize: 12, color: '#E65100', lineHeight: 1.6,
        }}>
          📋 사업자 등록증으로 등급업이 필요해요.<br />
          <span style={{ color: '#999' }}>Pro 등급 이상에서 위치를 직접 선택할 수 있어요.</span>
          <button
            type="button"
            onClick={() => setShowUpgradeMsg(false)}
            style={{ float: 'right', border: 'none', background: 'none', cursor: 'pointer', color: '#999', fontSize: 12 }}
          >
            닫기
          </button>
        </div>
      )}
    </div>
  );
}

function todayParts() {
  const t = new Date();
  return { year: t.getFullYear(), month: t.getMonth() + 1, day: t.getDate() };
}

function toDateStr(year, month, day) {
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}


export default function BusinessWriteModal({ onClose, userPosition, pickedLocation, canPickLocation, onPickLocation, user, displayName, canAlwaysOn }) {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [category, setCategory] = useState('food');
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [durationType, setDurationType] = useState('range');

  const today = todayParts();
  const [startYear, setStartYear] = useState(today.year);
  const [startMonth, setStartMonth] = useState(today.month);
  const [startDay, setStartDay] = useState(today.day);
  const [endYear, setEndYear] = useState(today.year);
  const [endMonth, setEndMonth] = useState(today.month);
  const [endDay, setEndDay] = useState(today.day);

  const handleImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImage(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleSubmit = async () => {
    if (!title.trim() || !content.trim()) return;
    setLoading(true);
    try {
      let imageUrl = null;
      if (image) imageUrl = await uploadImage(image);

      const startDate = toDateStr(startYear, startMonth, startDay);
      const alwaysOn = durationType === 'unlimited';
      const eventDate = durationType === 'oneday'
        ? startDate
        : durationType === 'unlimited'
          ? null
          : toDateStr(endYear, endMonth, endDay);

      const expiresAt = alwaysOn
        ? new Date(Date.now() + 100 * 365 * 24 * 60 * 60 * 1000)
        : new Date(eventDate + 'T23:59:59');
      const isUpcoming = new Date(startDate) > new Date();

      await addDoc(collection(db, 'posts'), {
        title, content, imageUrl, category,
        lat: userPosition[0], lng: userPosition[1],
        uid: user.uid, displayName,
        type: 'business', alwaysOn,
        startDate,
        eventDate: alwaysOn ? '상시 운영' : eventDate,
        isUpcoming,
        createdAt: serverTimestamp(),
        expiresAt,
      });
      onClose();
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  const isValid = title.trim() && content.trim();

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
      <div style={{ background: 'white', borderRadius: '16px 16px 0 0', padding: '20px 16px', width: '100%', maxWidth: 480, boxSizing: 'border-box', display: 'flex', flexDirection: 'column', gap: 12, maxHeight: '90vh', overflowY: 'auto', overflowX: 'hidden' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 style={{ margin: 0, fontSize: 16 }}>행사/업체 등록 🏪</h2>
          <button type="button" onClick={onClose} style={{ border: 'none', background: 'none', fontSize: 20, cursor: 'pointer' }}>✕</button>
        </div>

        <div>
          <p style={{ margin: '0 0 8px', fontSize: 13, fontWeight: 500 }}>카테고리</p>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {BUSINESS_CATEGORIES.map(c => (
              <button type="button" key={c.key} onClick={() => setCategory(c.key)} style={{
                padding: '6px 12px', borderRadius: 20, fontSize: 12,
                border: category === c.key ? '2px solid #333' : '1.5px solid #ddd',
                background: category === c.key ? '#333' : 'white',
                color: category === c.key ? 'white' : '#333',
                cursor: 'pointer',
              }}>
                {c.emoji} {c.label}
              </button>
            ))}
          </div>
        </div>

        <LocationSection
          canPickLocation={canPickLocation}
          pickedLocation={pickedLocation}
          onPickLocation={onPickLocation}
        />

        <input
          placeholder="행사/업체명"
          value={title} onChange={e => setTitle(e.target.value)}
          style={{ padding: '10px 12px', borderRadius: 8, border: '1px solid #ddd', fontSize: 16 }}
        />
        <textarea
          placeholder="행사 설명, 운영 시간 등을 입력해주세요"
          value={content} onChange={e => setContent(e.target.value)}
          rows={3}
          style={{ padding: '10px 12px', borderRadius: 8, border: '1px solid #ddd', fontSize: 16, resize: 'none', fontFamily: 'sans-serif' }}
        />

        <div style={{ display: 'flex', gap: 8 }}>
          {[{ key: 'oneday', label: '하루 행사' }, { key: 'unlimited', label: '무기한 행사' }].map(d => (
            <button
              type="button"
              key={d.key}
              onClick={() => setDurationType(durationType === d.key ? 'range' : d.key)}
              style={{
                flex: 1, padding: '8px 0', borderRadius: 8, fontSize: 13, cursor: 'pointer',
                border: durationType === d.key ? '2px solid #333' : '1.5px solid #ddd',
                background: durationType === d.key ? '#333' : 'white',
                color: durationType === d.key ? 'white' : '#555',
                fontWeight: durationType === d.key ? 600 : 400,
              }}
            >
              {d.label}
            </button>
          ))}
        </div>

        {durationType !== 'unlimited' && (
          <div>
            <p style={{ margin: '0 0 6px', fontSize: 13, fontWeight: 500 }}>
              {durationType === 'oneday' ? '행사 날짜' : '시작일'}
              <span style={{ color: '#999', fontWeight: 400, fontSize: 12 }}> (미래 날짜면 사전광고로 표시)</span>
            </p>
            <DateWheelPicker
              year={startYear} month={startMonth} day={startDay}
              onYearChange={setStartYear} onMonthChange={setStartMonth} onDayChange={setStartDay}
            />
          </div>
        )}

        {durationType === 'range' && (
          <div>
            <p style={{ margin: '0 0 6px', fontSize: 13, fontWeight: 500 }}>종료일</p>
            <DateWheelPicker
              year={endYear} month={endMonth} day={endDay}
              onYearChange={setEndYear} onMonthChange={setEndMonth} onDayChange={setEndDay}
            />
            <p style={{ margin: '4px 0 0', fontSize: 11, color: '#999' }}>종료일 자정에 자동 삭제됩니다</p>
          </div>
        )}

        {preview && (
          <div style={{ position: 'relative' }}>
            <img src={preview} alt="" style={{ width: '100%', borderRadius: 8, maxHeight: 200, objectFit: 'cover' }} />
            <button type="button" onClick={() => { setImage(null); setPreview(null); }} style={{ position: 'absolute', top: 8, right: 8, background: 'rgba(0,0,0,0.5)', color: 'white', border: 'none', borderRadius: '50%', width: 24, height: 24, cursor: 'pointer', fontSize: 12 }}>✕</button>
          </div>
        )}

        <div style={{ display: 'flex', gap: 10 }}>
          <label style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: '1px solid #ddd', background: 'white', fontSize: 13, cursor: 'pointer', textAlign: 'center' }}>
            📷 사진 추가
            <input type="file" accept="image/*" onChange={handleImage} style={{ display: 'none' }} />
          </label>
          <button
            type="button"
            onClick={handleSubmit} disabled={loading || !isValid}
            style={{ flex: 2, padding: '10px 0', borderRadius: 8, border: 'none', background: isValid ? '#333' : '#ccc', color: 'white', fontSize: 14, cursor: isValid ? 'pointer' : 'default' }}
          >
            {loading ? '등록 중...' : '📌 지도에 등록하기'}
          </button>
        </div>
      </div>
    </div>
  );
}
